// extracted by mini-css-extract-plugin
export default {"slider":"sliderComponent_slider__yG7Kd"};